import { useBienContext } from '../BienContext'

import { Input } from '@/components/ui'
import DetailTemplate from '@/components/DetailTemplate'
import EditButtons from '../EditButtons'
import { formatPrice } from '@/utils/formatters'
import Form from './Form'

export default () => {
  const { bien, updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = 'fiscalite'
  const SECTION_TITLE = "Fiscalité"

  const modalContent = <Form title={SECTION_TITLE} />
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier la fiscalité"
  />

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 3}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className="space-y-4">
        <Input.Display label="Taxe foncière" value={formatPrice(bien.montant_taxe_fonciere)} valueClassName="uppercase" />
      </div>
      <div className="space-y-4">
        <Input.Display label="Dispositif fiscal" value={bien.dispositif_fiscal} valueClassName="uppercase" />
      </div>
      <div className="space-y-4">
        <Input.Display label="Procédure" value={bien.procedure} valueClassName="uppercase" />
      </div>

    </DetailTemplate>
  )
}